import React from 'react';
import { Table, Card } from 'antd';
import styles from './Network.module.scss';

const NetworkPci = ({ pciData }) => {
  // PCI 데이터 파싱
  const parsePciData = (data) => {
    if (!data || data === 'N/A') return [];
    
    try {
      const devices = [];
      const lines = data.trim().split('\n');
      
      let currentDevice = null;
      
      lines.forEach(line => {
        if (line.match(/^([0-9a-f]{2}:[0-9a-f]{2}\.[0-9a-f]) /i)) {
          // 새 PCI 장치 시작
          const match = line.match(/^([0-9a-f]{2}:[0-9a-f]{2}\.[0-9a-f]) (.+?)(?:\[([^\]]+)\])?(?:: (.+))?$/i);
          if (match) {
            currentDevice = {
              pciAddress: match[1],
              deviceType: match[2].trim(),
              deviceId: match[3] || 'N/A',
              description: match[4] || 'N/A',
              details: [],
              key: match[1]
            };
            devices.push(currentDevice);
          }
        } else if (currentDevice && line.trim()) {
          // 장치 세부 정보
          currentDevice.details.push(line.trim());
        }
      });
      
      // 네트워크 관련 장치만 필터링
      return devices.filter(device => 
        device.deviceType.toLowerCase().includes('network') || 
        device.deviceType.toLowerCase().includes('ethernet')
      );
    } catch (error) {
      console.error('Error parsing PCI data:', error);
      return [];
    }
  };

  const networkDevices = parsePciData(pciData);

  return (
    <Card title="네트워크 PCI 장치 정보" className={styles.networkCard}>
      <Table 
        dataSource={networkDevices}
        rowKey="pciAddress"
        pagination={false}
        expandable={{
          expandedRowRender: record => (
            <div className={styles.expandedRow}>
              <h4>상세 정보</h4>
              <ul>
                {record.details.map((detail, index) => (
                  <li key={index}>{detail}</li>
                ))}
              </ul>
            </div>
          )
        }}
        columns={[
          { title: 'PCI 주소', dataIndex: 'pciAddress', key: 'pciAddress' },
          { title: '장치 유형', dataIndex: 'deviceType', key: 'deviceType' },
          { title: '장치 ID', dataIndex: 'deviceId', key: 'deviceId' },
          { title: '설명', dataIndex: 'description', key: 'description' }
        ]}
      />
    </Card>
  );
};

export default NetworkPci;